var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4312 54.0019C37.8447 52.4154 35.2725 52.4154 33.686 54.0019C32.0995 55.5884 32.0995 58.1606 33.686 59.7471L62.1235 88.1846C63.71 89.7711 66.2822 89.7711 67.8687 88.1846L96.3062 59.7471C97.8927 58.1606 97.8927 55.5884 96.3062 54.0019C94.7197 52.4154 92.1475 52.4154 90.561 54.0019L69.0665 75.4963V28.438C69.0665 26.1943 67.2477 24.3755 65.004 24.3755C62.7604 24.3755 60.9415 26.1943 60.9415 28.438V75.5122L39.4312 54.0019Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 97.5V109.688C12.1875 114.175 15.8252 117.812 20.3125 117.812H105.625C110.112 117.812 113.75 114.175 113.75 109.687V97.5",
    stroke: "currentColor",
    strokeWidth: 8.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBig);
export default __webpack_public_path__ + "static/media/uploadBig.c9c350da2dad68f84e6d06dd173c2f34.svg";
export { ForwardRef as ReactComponent };